<template>
    <div class="improveasy-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Homeowner Finance in partnership with Improveasy
                </div>
                <div class="logo">
                    <img src="/images/Improveasy-logo-small.png" style="height: 45px;">
                </div>
            </div>
            <div class="box-1">
                <h1>
                    Improveasy Finance Solutions
                </h1>
                <p>
                    With Improveasy you can offer your customers flexible finance options such as ‘Interest Free’ or ‘Buy
                    Now Pay Later’.
                </p>
                <div>
                    <a href="https://improveasy.com/easy-finance/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                        <strong>Apply Now</strong>
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/installer-benefits-homeowner-finance-header.jpg">
            </div>
            <div class="box-2">
                <p>
                    Improveasy finance solutions are a specialist home improvement finance company offering a wide range of finance solutions including:
                </p>
                <p>
                <ul>
                    <li>0% interest free finance</li>
                    <li>A range of APRs to suit your products</li>
                    <li>Up to 10 years finance</li>
                    <li>Finance available for all home improvements</li>
                </ul>
                </p>
                <div class="btn-primary-outline _lg" @click.stop="enquiry_box_open = true">
                    Make Enquiry
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Homeowner Finance Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information on signing up for Improveasy',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 15,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Improveasy enquiry',
                'value': 'Improveasy enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Improveasy`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Improveasy partner link clicked',
          'value': 'Improveasy partner link clicked',
        });
      },
    },
};
</script>
